define('modules/player/media/central/central_media_collection_item_view',[
  'backbone',
  'jquery',
  '_',
  'session',

  'modules/util/collection/collection_view',
  'modules/htmlad/player/htmlad_player_view',
  'modules/video/player/video_player_view',
  'modules/item_image/image_player/image_player_view',

  'text!./central_media_header_template.html',
  'text!./central_media_list_item_template.html'
], function (Backbone, $, _, session,
             CollectionView,
             HtmlAdPlayer,
             VideoView,
             ImagePlayerView,
             header_template,
             list_template) {
  'use strict';
  var View = Backbone.View.extend({
    initialize: function (opts) {
      _.extend(this, opts);

      this.viewType = (this.viewType) ? this.viewType : CollectionView.LIST;

      this.listenTo(this.model, 'change:confirm-removal', function (model) {
        this.$('.delete-item')[model.get('confirm-removal') ? 'addClass' : 'removeClass']('confirm');
      }, this);

      this.render();
    },

    subViews: [],
    tagName: 'div',

    list_template: _.template(list_template),

    events: {
      'click .js-disconnect-location': 'clickDisconnectAdFromLocation',
      'click .js-preview-ad': 'previewAd'
    },

    render: function () {
      var json = this.model.toJSON();
      $.extend(json, this.extraParams);

      this.$el.html(this.list_template(json));

      return this;
    },

    previewAd: function (e) {
      e.preventDefault();
      var $item = $(e.currentTarget).closest('.player-items');
      var mediaFormat = $item.data('media-format');

      if(mediaFormat === 'html') {
        this.previewHtmlAd();
      } else {
        this.previewVideoAd();
      }
    },

    previewHtmlAd: function () {
      var self = this;

      var htmlAdPlayer = new HtmlAdPlayer({
        model: self.model,
        fitHeight: 600,
        close: function () {
          self.$('.js-preview-ad-container').removeClass('ad-preview').empty();
          this.remove();

        }
      });
      this.$('.js-preview-ad-container').html(htmlAdPlayer.$el).addClass('ad-preview');

      //toggle buttons
      this.$('.js-preview-htmlad').addClass('is-hidden');
      this.$('.js-edit-htmlad').removeClass('is-hidden');

      // toggle form
      this.$('.js-form-content').addClass('is-hidden');
      // and buttons
      this.$('.form-buttons').addClass('is-hidden');
    },

    previewVideoAd: function () {
      if (session.has('current_preview')) {
        session.get('current_preview').close();
      }

      var mediaData = {
        model: this.model,
        onClose: this.closePreview.bind(this)
      };

      var media;
      if (this.model.get('metadata').format === 'video') {
        media = new VideoView(mediaData);
      } else {
        media = new ImagePlayerView(mediaData);
      }

      session.set('current_preview', media);
      this.$el.addClass('is-active');
      this.$('.js-preview-ad-container').html(media.$el).addClass('is-open');
    },

    closePreview: function () {
      session.unset('current_preview');
      this.$el.removeClass('is-active');
      this.$('.js-preview-ad-container').removeClass('is-open');
    },

    clickDisconnectAdFromLocation: function (e) {
      e.preventDefault();
      var t = setTimeout(function () {
        this.model.set('confirm-removal', false);
      }.bind(this), 3000);

      if (this.model.get('confirm-removal')) {
        clearTimeout(t);
        $.ajax({
          type: 'POST',
          contentType: 'application/json; charset=UTF-8',
          url: session.get('apiUrl') + 'bookings/' + this.model.get('booking_id') + '/removelocation/' + session.get('location_id')
        }).success(function (data) {
          this.$el.fadeOut(200);
          setTimeout(function () {
            this.remove();
          }.bind(this), 200);
        }.bind(this));
      } else {
        this.model.set('confirm-removal', true);
      }
    },

    remove: function () {
      _.each(this.subViews, function (view) {
        if (view && view.remove) {
          view.remove();
        }
      });
      this.$el.off();
      this.$el.remove();
      this.stopListening();
      return this;
    }

  }, {
    header: function (collection) {
      return _.template(header_template)(collection.params);
    },
    viewTypes: [CollectionView.LIST]
  });
  return View;
});

